export default "__VITE_ASSET__D$uPSVck__"